import { c as _c } from "react/compiler-runtime";
import { Block } from "@opensea/ui-kit";
import { track } from "../client";
import { extractProperties } from "../lib/helpers";
/**
 * Component level tracking for click, focus, and blur events
 */
export function Track(t0) {
  const $ = _c(11);
  const {
    children,
    click,
    focus,
    blur
  } = t0;
  let t1;
  if ($[0] !== click) {
    t1 = click ? e => {
      const {
        event,
        data
      } = click;
      track(event, {
        ...extractProperties(e),
        ...data
      });
    } : undefined;
    $[0] = click;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onClick = t1;
  let t2;
  if ($[2] !== focus) {
    t2 = focus ? e_0 => {
      const {
        event: event_0,
        data: data_0
      } = focus;
      track(event_0, {
        ...extractProperties(e_0),
        ...data_0
      });
    } : undefined;
    $[2] = focus;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const onFocus = t2;
  let t3;
  if ($[4] !== blur) {
    t3 = blur ? e_1 => {
      const {
        event: event_1,
        data: data_1
      } = blur;
      track(event_1, {
        ...extractProperties(e_1),
        ...data_1
      });
    } : undefined;
    $[4] = blur;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const onBlur = t3;
  let t4;
  if ($[6] !== children || $[7] !== onBlur || $[8] !== onClick || $[9] !== onFocus) {
    t4 = <Block asChild={true} onBlur={onBlur} onClick={onClick} onFocus={onFocus}>{children}</Block>;
    $[6] = children;
    $[7] = onBlur;
    $[8] = onClick;
    $[9] = onFocus;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}